export const AllDayStartHour = 8;
export const AllDayEndHour = 16;

/** Prefilled length of a new appointment (Termin), the same for every purpose (Terminart). */
export const DefaultAppointmentDurationMinutes = 30;

/** A new appointment's prefilled start is now, rounded up to the next step of this size. */
export const DefaultAppointmentStartStepMinutes = 30;

/** Days of the Mon–Fri attendance week — the planning window and the overview's day columns. */
export const WEEKDAY_COUNT = 5;

/**
 * Preselected Terminort when a configured Zweck is picked. The Ort is an ordinary admin-managed
 * dropdown, so the column holds this German label itself — it must stay spelled exactly as the
 * MoveAppointmentLocationToRegularDropdowns migration seeds it, or the preselect matches no option.
 */
export const DefaultAppointmentLocation = "Telefon";
